module.exports = __webpack_public_path__ + "static/media/instagram-bold.3372164e.svg";